module.exports = __webpack_public_path__ + "img/90.40ce646c.jpg";